export function checkbox() {
    require('jquery')
    require('iCheck')
    $('input').iCheck()
}



/** WEBPACK FOOTER **
 ** ./assets/app/component/checkbox/checkbox.js
 **/